import { useMemo } from 'react'
import { CheckoutStatusType } from 'types/checkout'
import isAfter from 'date-fns/isAfter'
import { StockUnionType } from 'types/stock'

const useCanBeCanceled = (
  cancelDeadline: Date,
  isDelivered: boolean,
  status: CheckoutStatusType,
  type: StockUnionType
): boolean => {
  return useMemo(() => {
    if (!cancelDeadline) return false
    return (
      isAfter(cancelDeadline, new Date()) &&
      !isDelivered &&
      status === 'requires_capture' &&
      (type === 'preorder' || type === 'delivery')
    )
  }, [cancelDeadline, isDelivered, status, type])
}

export default useCanBeCanceled
